angular.module('leanlaw').controller('SummaryBillableController', ['$scope', "userService", "reportsService", "messageBus", "singleRequest", function ($scope, userService, reportsService, messageBus, singleRequest) {
  //
  function load() {
    var query = queryFromFilter();
    if (!query) return; // Not ready yet

    query.data = 'hours,services,expenses,charges';
    query.billed = 'false';
    $scope.notBilled = {
      loading: true
    };
    query.primary = 'clients';
    singleRequest.apiCall("notbilled").getReport(query).then(function (data) {
      if (!data) return; // Cancelled
      var cm = getClientMatter(data);
      $scope.notBilled = cm.data;
    });
    userService.me().then(function (me) {
      $scope.trust = me.company.settings.trustEnabled;
      $scope.accounting = me.company.integration.quickbooks;
      if ($scope.accounting) {
        $scope.billed = {
          loading: true
        };
        query.data = 'hours,services,expenses,charges,invoices,receivables,payments';
        if ($scope.trust) {
          query.data += ',trust';
        }
        query.billed = 'true';
        query.billedState = undefined;
        query.primary = 'clients';
        singleRequest.apiCall("billed").getReport(query).then(function (data) {
          if (!data) return; // Cancelled
          var cm = getClientMatter(data);
          adjustLastPayment(cm);
          $scope.billed = cm.data;
        });
      }
    });
  }
  function getClientMatter(data) {
    var client = data.clients[0];
    var cm = $scope.cm.matter && client ? client.matters[0] : client;
    // This happens if we don't have any data returned for this client/matter in which case we just
    // use the .data attribute in the response which is a bunch of zeros. Sort of hacky.
    if (cm == null) cm = data.data;
    return cm;
  }
  function queryFromFilter() {
    if (!$scope.filter) return; // Not ready yet
    if (!$scope.filter.filter) return;
    if (!$scope.cm) return;
    console.log("f", $scope.filter);
    var query = reportsService.queryFromFilter($scope.filter);
    if (!query) return;
    query.scope = null;
    if ($scope.cm.matter) {
      query.matterId = $scope.cm.matter.id;
    } else {
      query.clientId = $scope.cm.client.id;
    }
    return query;
  }
  function adjustLastPayment(cm) {
    // Roll up matter payments into last client payments
    if ($scope.cm.matters) {
      var last = $scope.cm.matters.reduce((accum, matter) => {
        return latest(matter.data.accounting.lastPayment, accum);
      }, $scope.cm.data.accounting.lastPayment);
      $scope.cm.data.accounting.lastPayment = last;
    }
  }
  function latest(p1, p2) {
    if (!p1) return p2;
    if (!p2) return p1;
    if (new Date(p1.date) > new Date(p2.date)) {
      return p1;
    }
    return p2;
  }
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    console.log("load overview cfs", payload);
    load();
  });
  $scope.$on("report-sidebar-filterchange", (event, payload) => {
    console.log("load overview", payload);
    load();
  });
  $scope.$watch("cm", newValue => {
    load();
  });

  // MessageBus is used here so that the commonFilter module can pick it up once it loads
  messageBus.addMessage("filterDependency-ready", true);
}]);